import { Link } from 'react-router-dom';
import { useCart } from '@/contexts/CartContext';
import { Button } from '@/components/ui/button';
import { Minus, Plus, Trash2 } from 'lucide-react';
import { fileUrl } from '../lib/utils';

const Cart = () => {
  const { items, removeFromCart, updateQuantity, total } = useCart();

  if (items.length === 0) {
    return (
      <div className="container mx-auto px-4 py-16 text-center">
        <h1 className="text-3xl font-light mb-4">Таны сагс хоосон байна</h1>
        <Link to="/shop">
          <Button>Бүтээгдэхүүн үзэх</Button>
        </Link>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-16">
      <h1 className="text-3xl font-light mb-8">Миний сагс</h1>
      
      <div className="grid lg:grid-cols-3 gap-8">
        <div className="lg:col-span-2 space-y-4">
          {items.map((item) => (
            <div key={item.id} className="flex gap-4 border border-border p-4 rounded-sm">
              <img
                src={fileUrl(item.thumbnail || '')}
                alt={item.name}
                className="w-24 h-24 object-cover rounded-sm"
              />
              
              <div className="flex-1">
                <h3 className="font-medium mb-2">{item.name}</h3>
                <p className="text-primary font-semibold mb-4">
                  {item.price.toLocaleString('mn-MN')}₮
                </p>
                
                <div className="flex items-center gap-4">
                  <div className="flex items-center border border-border rounded-sm">
                    <button
                      onClick={() => updateQuantity(item.id, item.quantity - 1)}
                      className="p-2 hover:bg-muted transition-colors"
                    >
                      <Minus className="h-4 w-4" />
                    </button>
                    <span className="px-4 py-2 min-w-[60px] text-center">{item.quantity}</span>
                    <button
                      onClick={() => updateQuantity(item.id, item.quantity + 1)}
                      className="p-2 hover:bg-muted transition-colors"
                    >
                      <Plus className="h-4 w-4" />
                    </button>
                  </div>
                  
                  <button
                    onClick={() => removeFromCart(item.id)}
                    className="text-destructive hover:text-destructive/80"
                  >
                    <Trash2 className="h-5 w-5" />
                  </button>
                </div>
              </div>
              
              <div className="text-right">
                <p className="font-semibold">
                  {(item.price * item.quantity).toLocaleString('mn-MN')}₮
                </p>
              </div>
            </div>
          ))}
        </div>
        
        <div className="border border-border p-6 rounded-sm h-fit">
          <h2 className="text-xl font-medium mb-4">Нийт дүн</h2>
          
          <div className="space-y-2 mb-6">
            <div className="flex justify-between">
              <span>Бараа ({items.length})</span>
              <span>{total.toLocaleString('mn-MN')}₮</span>
            </div>
            <div className="flex justify-between font-semibold text-lg pt-4 border-t border-border">
              <span>Нийт</span>
              <span className="text-primary">{total.toLocaleString('mn-MN')}₮</span>
            </div>
          </div>
          
          <Link to="/checkout">
            <Button className="w-full">Үргэлжлүүлэх</Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Cart;
